export const companyConfig = {
  name:
    import.meta.env.VITE_COMPANY_NAME ?? "East African Tea Trade Association",

  logo: import.meta.env.VITE_COMPANY_LOGO ?? "/eatta-logo.png",

  officePhone: import.meta.env.VITE_COMPANY_OFFICE_PHONE ?? "+254 722 208 699",

  email: import.meta.env.VITE_COMPANY_EMAIL ?? "info@eatta.co.ke",

  website: import.meta.env.VITE_COMPANY_WEBSITE ?? "https://www.eatta.co.ke",

  location:
    import.meta.env.VITE_COMPANY_LOCATION ??
    "Nyerere Avenue, P.O. Box 85174 - 80100 Mombasa, Kenya",
};
